import { Map } from 'immutable';

import * as types from './types';


const initialState = Map({
  Browser: true,
  Build: true,
  Date: true,
  Duration: true,
  Name: true,
  OS: true,
  Owner: true,
});


const parseColumns = (columns) => columns.reduce((acc, column) => (
  acc.set(column.name, column.visible)
), Map());

const columnsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET.SUCCESS:
    case types.PUT.SUCCESS:
      return state.merge(parseColumns(payload.columns));
    case types.TOGGLE:
      return state.set(payload, !state.get(payload));
    default:
      return state;
  }
};

export default columnsReducer;
